const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    data-testid="icon-close"
  >
    <path
      d="M1 15L4.75 11.25M15 7C15 10.3137 12.3137 13 9 13C5.68629 13 3 10.3137 3 7C3 3.68629 5.68629 1 9 1C12.3137 1 15 3.68629 15 7Z"
      stroke="#373738"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export default SearchIcon;
